const { useCallback } = require('react')

const useSearch = () => {
    const isAddress = useCallback(address => {
        let addressLower = address.toLowerCase()
        if (!/^(0x)?[0-9a-f]{40}$/i.test(addressLower)) {
            return false
        } else if (/^(0x)?[0-9a-f]{40}$/.test(addressLower) || /^(0x)?[0-9A-F]{40}$/.test(addressLower)) {
            return true
        } else {
            return this.isChecksumAddress(addressLower)
        }
    }, [])

    const isTxHash = useCallback(tx => {
        if (!/^0x([A-Fa-f0-9]{64})$/i.test(tx)) {
            return false
        }
        return true
    }, [])

    const isBlockNumber = useCallback(blockNum => {
        if (parseInt(blockNum) == blockNum) {
            return true
        }
        return false
    }, [])

    const handleSearch = useCallback(searchValue => {
        searchValue = searchValue.toLowerCase()

        if (searchValue.length === 66) {
            return `tx/${searchValue}`
        } else if (searchValue.length === 42) {
            return `address/${searchValue}`
        } else {
            if (searchValue.startsWith('0x')) return `block/${parseInt(searchValue, 16)}`
            else return `block/${searchValue}`
        }
    }, [])

    return {
        handleSearch,
        isAddress,
        isTxHash,
        isBlockNumber
    }
}

module.exports = {
    useSearch
}
